import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-icon_collapse",
  "use": "icon-menu-icon_collapse-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-menu-icon_collapse\"><path fill=\"currentColor\" d=\"M21 3.5v10l-5-5zM21 20v-2H3v2zm-9-7v-2H3v2zm0-7V4H3v2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol